export type QuoteFiltersFromUrl = Partial<{
	journeyId: string;
	quoteRefNo: string;
	planTypeId?: string | undefined;
	sortId?: string | undefined;
	insurerCompanyId?: string | undefined;
	opConsultationCoPaymentId?: string | undefined;
	networkId?: string | undefined;
	pharmacyCoPaymentId?: string | undefined;
	diagnosticCoPaymentId?: string | undefined;
	keyBenefitId?: string | undefined;
	investorOrPartner?: string;
}>;

export const useInitialValuesFromUrl = (initialValuesFromUrl: QuoteFiltersFromUrl) => {
	const {
		insurerCompanyId,
		opConsultationCoPaymentId,
		diagnosticCoPaymentId,
		networkId,
		keyBenefitId,
		pharmacyCoPaymentId,
		investorOrPartner,
	} = initialValuesFromUrl;

	const mapToStringArray = (formIds: string | undefined) => {
		return formIds ? String(formIds)?.split(',') : undefined;
	};

	const mapToNumberArray = (formIds: string | undefined) => {
		return formIds ? String(formIds)?.split(',').map(Number) : undefined;
	};

	const icId = Number(insurerCompanyId);
	const keyBenefitIds = mapToNumberArray(keyBenefitId);
	const networkIds = mapToNumberArray(networkId);
	const opConsultationCoPaymentIds = mapToStringArray(opConsultationCoPaymentId);
	const pharmacyCoPaymentIds = mapToStringArray(pharmacyCoPaymentId);
	const diagnosticCoPaymentIds = mapToStringArray(diagnosticCoPaymentId);

	const filterInitialValues = {
		insurerCompanyId: icId,
		opConsultationCoPaymentId: opConsultationCoPaymentIds,
		diagnosticCoPaymentId: diagnosticCoPaymentIds,
		pharmacyCoPaymentId: pharmacyCoPaymentIds,
		networkId: networkIds,
		keyBenefitId: keyBenefitIds,
		investorOrPartner: investorOrPartner ? 1 : 0,
	};

	return { filterInitialValues };
};
